<template>
  <main>
    <datetime :min-datetime="minDatetime"
              :max-datetime="maxDatetime"
              :phrases="{ok: 'OK', cancel: 'キャンセル'}"
              :disabled="sending"
              :required="required"
              :value="datetime"
              :format="format"
              :type="format === 'yyyy-MM-dd HH:mm' ? 'datetime' : `date`"
              @input="inputDatetime"
              value-zone="Asia/Tokyo"
              zone="Asia/Tokyo">
      <label v-if="label">{{label}}</label>
    </datetime>
  </main>
</template>

<script>
  import moment from "moment";

  export default {
    name      : "DatetimePicker",
    components: {},
    props     : {
      value      : null,
      label      : {
        type    : String,
        required: false,
        default : null,
      },
      minDatetime: {
        type    : Date | null,
        required: false,
        default : null,
      },
      maxDatetime: {
        type    : Date | null,
        required: false,
        default : null,
      },
      sending    : {
        type    : Boolean,
        required: false,
        default : false,
      },
      required   : {
        type    : Boolean,
        required: false,
        default : false,
      },
      format     : {
        type    : String,
        required: false,
        default : 'yyyy-MM-dd',
      }
    },
    data      : () => ({
      datetime : null,
      initValue: null,
    }),
    created() {
      this.datetime   = this.value;
      this.initValue  = this.value;
    },
    methods   : {
      /**
       * 日付の入力を親コンポーネントに渡す
       * @param value
       */
      inputDatetime       : function (value) {
        this.$emit('input', value)
      },
      /**
       * 日付を整形して再表示する
       * @param value
       * @param inBlur
       */
      formatDatetime      : function (value, inBlur = false) {
        const numberMaxLength = this.$props.format === 'yyyy-MM-dd HH:mm' ? 12 : 8;

        // 数字と半角スペースとハイフンのみ入力を許す
        const numberHyphenOnly = value.replace(/[^\d\s\-:]/g, ' ');
        if (numberHyphenOnly !== value) {
          this.datetime = numberHyphenOnly;
          return;
        }

        // 数値だけで8桁(12桁)ない場合は処理しない
        const numberOnly = value.match(/\d/ig) ? value.match(/\d/ig).join('') : '';
        if (numberOnly === '' || numberOnly.length < numberMaxLength) {
          if (inBlur) {
            this.datetime = this.initValue;
          }
          return;
        }

        // 日付でない場合は初期化
        if (numberOnly.length === numberMaxLength && !moment(numberHyphenOnly).isValid()) {
          if (inBlur) {
            this.datetime = this.initValue;
          } else {
            this.datetime = '';
          }
          return;
        }

        // 指定の形式にフォーマット
        const format  = this.$props.format
          .replace('yyyy-MM-dd HH:mm', 'YYYY-MM-DD HH:mm')
          .replace('yyyy-MM-dd', 'YYYY-MM-DD');
        this.datetime = moment(numberHyphenOnly).format(format);
      },
      /**
       * プレースホルダーを生成
       */
      placeholder         : function () {
        // フォーマットの英字を0に置き換えて代用
        return this.$props.format.replace(/[a-zA-Z]/g, '0');
      }
    }
  }
</script>

<style lang="scss" scoped>
  main {
    width: 100%;
  }

  .datetime-picker {
    border: none;
    padding: 0.5em;
    width: 100%;
    font-size: 1.2em;
    line-height: 1.2;
  }
</style>
